import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  rowemail: { padding: '0 0 24px 0' },
  paper: {
    minWidth: '50%',
    maxWidth: '822px',
    maxHeight: '90%',
    overflowY: 'auto',
  },
  topBar: {
    backgroundColor: '#F6F6F6',
    padding: '20px 24px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '133.4%',
    color: '#000000',
  },
  text: {
    width: '100%',
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    fontSize: 15,
    color: 'black',
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  row: {
    alignItems: 'center',
    marginTop: '24px',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  filerow: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  fullRow: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '100%',
    flexWrap: 'wrap',
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  flexBox: {
    display: 'flex',
    padding: '24px',
  },
  profileContainer: {
    marginRight: 32,
    width: 192,
  },
  formContainer: {
    flex: 1,
  },
  errorFormControl: {
    width: '100%',
    marginTop: theme.spacing(-0.3),
    marginBottom: theme.spacing(-0.3),
  },
  errorText: {
    color: theme.palette.error.main,
  },
  subTitle: {
    fontSize: 12,
    textTransform: 'uppercase',
    lineHeight: '32px',
    letterSpacing: 1,
  },
  btn: {
    marginTop: theme.spacing(1),
    padding: '12px 22px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  textField: {
    width: '100%',
    marginRight: theme.spacing(2),
    //borderBottom: '1px solid #E0E0E0',
    //padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  space: {
    marginLeft: theme.spacing(1),
    cursor: 'pointer',
    color: 'red',
  },
  uploadtext: {
    marginTop: '22px',
    fontSize: '16px',
    lineHeight: '19px',
    fontWeight: 400,
    '& span': {
      color: '#5081FF',
      fontWeight: 600,
    },
  },
  uploadIcon: {
    fontSize: '32px',
    color: '#D2D2DF',
  },
  selectOption: {
    height: 'auto',
    width: '100%',
  },
  fileInfo: {
    height: '65px',
    alignItems: 'center',
    padding: '12px 16px',
    cursor: 'pointer',
    display: 'flex',
    width: '100%',
    background: '#F6F6F6',
    marginTop: '8px',
    borderRadius: '16px',
    fontSize: '16px',
    lineHeight: '19px',
    fontWeight: 400,
  },
  fileiconbtn: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  fileicon: {
    justifyContent: 'end',
    display: 'flex',
  },
  filename: {
    color: '#5081FF',
  },
  filesize: {
    color: '#0000008A',
  },
  textFileField: {
    borderRadius: '12px',
    textAlign: 'center',
    width: '100%',
    padding: '21px 0 16px 0',
    background: '#F6F6F6',
    cursor: 'pointer',
  },
  btnrow: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },

  bottomBtn: {
    height: 'auto',
  },
  bottomBtn1: {
    height: '103px',
  },
  nofilename: {
    fontSize: '12px',
    color: 'grey',
  },
  fileadjust: {
    wordBreak: 'break-all',
  },
  btn1: {
    marginRight: '12px',
    padding: '12px 25px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '& .MuiInputBase-input': {
      padding: ' 0',
      color: 'white',
    },
  },
  btn2: {
    // marginTop: theme.spacing(1),
    marginLeft: '12px',
    padding: '12px 5px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '& .MuiInputBase-input': {
      padding: ' 0',
      color: 'white',
    },
  },

  emailHeader: {
    background: '#363473',
    height: '50px',
    alignItems: 'center',
    marginTop: '5px',
    marginBottom: '4.5px',
    padding: '0 12px',
  },
  labels: {
    color: '#363473',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: '160%',
    padding: '2px 0 0 40px',
  },
  details: {
    padding: '6px 0 0 40px',
    color: 'rgba(0, 0, 0, 0.64)',
  },
  btndetails: {
    color: 'rgba(0, 0, 0, 0.64)',
  },
  emailLink: {
    color: '#5081ff',
  },
  emailbtn: {
    borderBottom: '1px solid',
    padding: '0 0 8px 0',
    margin: '0 40px 0 40px',
    color: 'rgba(205, 218, 241, 1)',
  },
  system: {
    fontSize: '14px',
    padding: '4px 0 0 40px',
  },
  thanks: {
    '& .MuiInputBase-input': {
      fontWeight: 600,
      fontSize: '20px',
    },
  },
  admin: {
    '& .MuiInputBase-input': {
      color: 'rgba(0, 0, 0, 0.64)',
    },
  },
  callicon: {
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '8px 7px',
    borderRadius: '4px',
    '& .MuiSvgIcon-root ': {
      color: 'white',
      height: '18px',
      widthh: '18px',
    },
  },
  footerText: {
    color: 'white',
    marginLeft: '8px',
  },
}));
